export const eventFields = {
    CONSUMER: [
        {
            label: 'Event Attribute Is:',
            name: 'attributeName',
            type: 'dropdown',
            values: ['register', 'login'],
        },
    ],
    GAME: [
        {
            label: 'Event Attribute Is:',
            name: 'attributeName',
            type: 'dropdown',
            values: ['id'],
        },
        {
            label: 'Operation:',
            name: 'operation',
            type: 'dropdown',
            values: ['=='],
        },
        {
            label: 'Attribute Value Is:',
            name: 'attributeValue',
            type: 'text',
        },
    ],
    VIDEO: [
        {
            label: 'Event Attribute Is:',
            name: 'attributeName',
            type: 'dropdown',
            values: ['id'],
        },
        {
            label: 'Operation:',
            name: 'operation',
            type: 'dropdown',
            values: ['=='],
        },
        {
            label: 'Attribute Value Is:',
            name: 'attributeValue',
            type: 'text',
        },
    ],
    ARTICLE: [
        {
            label: 'Event Attribute Is:',
            name: 'attributeName',
            type: 'dropdown',
            values: ['id'],
        },
        {
            label: 'Operation:',
            name: 'operation',
            type: 'dropdown',
            values: ['=='],
        },
        {
            label: 'Attribute Value Is:',
            name: 'attributeValue',
            type: 'text',
        },
    ],
    QUIZ: [
        {
            label: 'Event Attribute Is:',
            name: 'attributeName',
            type: 'dropdown',
            values: ['id'],
        },
        {
            label: 'Operation:',
            name: 'operation',
            type: 'dropdown',
            values: ['=='],
        },
        {
            label: 'Attribute Value Is:',
            name: 'attributeValue',
            type: 'text',
        },
    ],
    RAFFLE: [
        {
            label: 'Event Attribute Is:',
            name: 'attributeName',
            type: 'dropdown',
            values: ['id'],
        },
        {
            label: 'Operation:',
            name: 'operation',
            type: 'dropdown',
            values: ['=='],
        },
        {
            label: 'Attribute Value Is:',
            name: 'attributeValue',
            type: 'text',
        },
    ],
};
export const conditionFields = {
    CONSUMER: [
        {
            label: 'Event Attribute Is:',
            name: 'attributeName',
            type: 'dropdown',
            values: ['eventFrequency', 'eventCount', 'points'],
        },
        {
            label: 'Operation:',
            name: 'operation',
            type: 'dropdown',
            values: ['==', '>', '<', '>=', '<='],
        },
        {
            label: 'Attribute Value Is:',
            name: 'attributeValue',
            type: 'text',
        },
    ],
    GAME: [
        {
            label: 'Event Attribute Is:',
            name: 'attributeName',
            type: 'dropdown',
            values: ['title'],
        },
        {
            label: 'Operation:',
            name: 'operation',
            type: 'dropdown',
            values: ['=='],
        },
        {
            label: 'Attribute Value Is:',
            name: 'attributeValue',
            type: 'text',
        },
    ],
    VIDEO: [
        {
            label: 'Event Attribute Is:',
            name: 'attributeName',
            type: 'dropdown',
            values: ['title'],
        },
        {
            label: 'Operation:',
            name: 'operation',
            type: 'dropdown',
            values: ['=='],
        },
        {
            label: 'Attribute Value Is:',
            name: 'attributeValue',
            type: 'text',
        },
    ],
    ARTICLE: [
        {
            label: 'Event Attribute Is:',
            name: 'attributeName',
            type: 'dropdown',
            values: ['title'],
        },
        {
            label: 'Operation:',
            name: 'operation',
            type: 'dropdown',
            values: ['=='],
        },
        {
            label: 'Attribute Value Is:',
            name: 'attributeValue',
            type: 'text',
        },
    ],
    QUIZ: [
        {
            label: 'Event Attribute Is:',
            name: 'attributeName',
            type: 'dropdown',
            values: ['title'],
        },
        {
            label: 'Operation:',
            name: 'operation',
            type: 'dropdown',
            values: ['=='],
        },
        {
            label: 'Attribute Value Is:',
            name: 'attributeValue',
            type: 'text',
        },
    ],
    RAFFLE: [
        {
            label: 'Event Attribute Is:',
            name: 'attributeName',
            type: 'dropdown',
            values: ['title'],
        },
        {
            label: 'Operation:',
            name: 'operation',
            type: 'dropdown',
            values: ['=='],
        },
        {
            label: 'Attribute Value Is:',
            name: 'attributeValue',
            type: 'text',
        },
    ],
};


export const entity = {
    domains: {
      DEVICE: {
        id: "",
        attributes: [
          {
            id: "",
            attrName: "device_type_code",
            label: "Device Code",
            operatorType: 'numeric',
            position: "",
            attrvalue: {
              type: "num",
              values: "",
            },
          },
          {
            id: "",
            attrName: "device_version_code",
            label: "Device Version",
            operatorType: 'numeric',
            position: "",
            attrvalue: {
              type: "multi-select",
              values: ['ILUPRI', 'ILUMA1', 'ILUMA'],
            },
          },
          {
            id: "",
            attrName: "warranty_end_date",
            label: "Warrenty End Date",
            operatorType: "staticTimeOperator",
            position: "",
            attrvalue: {
              type: "date",
              values: "",
            },
          },
          {
            id: "",
            attrName: "status_code",
            operatorType: 'numeric',
            position: "",
            attrvalue: {
              type: "Boolean",
              values: ['Yes', 'No'],
            },
          },
          {
              id: "",
              attrName: "registration_device_date",
              label: "Device Registration Date",
              operatorType: "dynamicTimeOperator",
              position: "",
              attrvalue: {
                type: "date",
                values: "",
              },
            }
        ],
      },
      ORDER: {
        id: "",
        attributes: [
          {
            id: "",
            attrName: "order_type",
            label: "Order Type",
            operatorType: 'ruleBased',
            position: "",
            attrvalue: {
              type: "select",
              values: ['ZLD', 'ZMD', 'ZNMD', 'ZND'],
            },
          },
          {
            id: "",
            attrName: "order_status",
            label: "Order Status",
            operatorType: 'ruleBased',
            position: "",
            attrvalue: {
              type: "multi-select",
              values: ['Completed', 'Not Started', 'In Progress'],
            },
          }
        ],
      }
    },
    operators: {
      numeric: [ '=','>','>=' ,'<' ,'<=' ,'> < ','< >'],
      ruleBased: ['is','is not','is multiple','is not multiple','is null','is not null','contains','not contains','starts with','not starts with','ends with','not ends with'],
      staticTimeOperator: ["after date","before date","between dates","not between dates","not on date","on or after date","on or before date"],
      dynamicTimeOperator: ["in_between_next_to","in_between_past_to","not_in_between_next_to","within_this","not_within_this","within_next","within_past","anniversary"]
    }
};
